import { defineAction } from '~/prix'
import viewListAction from './viewList.action.json' with { type: 'json' }
import { z } from 'zod'

const viewListDefinition = defineAction({
  ...viewListAction,

  input: z
    .object({
      search: z.string().trim().optional(),
      category: z.string().trim().optional(),
      path: z.string().trim().optional(),
      startIndex: z.number().min(0).optional(),
      endIndex: z.number().min(1).optional(),
      orderBy: z.enum(['relevance', 'title']).optional(),
    })
    .refine(data => (data.endIndex ?? 50) > (data.startIndex ?? 0), {
      message: 'endIndex must be greater than startIndex',
      path: ['endIndex'],
    }),
  output: z.object({
    items: z.array(z.any()).optional(),
    pagesLeft: z.number().optional(),
    variablesCount: z.number().optional(),
    total: z.number().optional(),
  }),

  cache: input => {
    if (input.search) {
      return {}
    }

    return {
      back: {
        // 2 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 2,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
      front: {
        // 5 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 5,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
    }
  },
})

export default viewListDefinition
